import { gql as individual_gql } from '@/modes/individual/gql';
import { gql as company_gql } from '@/modes/company/gql';
import { gql as waterSupplier_gql } from '@/modes/waterSupplier/gql';
import { ResultOf } from 'gql.tada';

export const GET_INBOUND_ASSIGNMENT_IDS = individual_gql(`#graphql
  query GetAssignmentIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
    $includeAddress: Boolean = false
  ) {
    inboundAssignments(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
      jobId
      job @include(if: $includeAddress) {
        id
        address {
          latitude
          longitude
        }
      }
    }
  }
`);

export const GET_INBOUND_ASSIGNMENTS_COMPANY = company_gql(`#graphql
  query GetAssignments(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    inboundAssignments(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      jobId
      status
      billingStatus
      created
      assigned
      completed
      submitted

      customerProfile {
        id
        name
        phones {
          id
          value
        }
      }

      child {
        id
        due
        vendorProfile {
          id
          name
        }
      }

      job {
        type
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        backflowTest {
          jobId
          dateTested
          initialResult
          finalResult
          backflowAssemblyEdited
          properlyInstalled
          testable
          waterSupplierProfile {
            id
            name
          }
          backflowAssembly {
            id
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
            waterService {
              id
              pin
            }
          }
        }
        attachments {
          id
        }
      }
    }
  }
`);

export const GET_INBOUND_ASSIGNMENTS_WATER_SUPPLIER =
  waterSupplier_gql(`#graphql
  query GetAssignments(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    inboundAssignments(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      jobId
      status
      billingStatus
      created
      assigned
      completed
      submitted

      customerProfile {
        id
        name
        phones {
          id
          value
        }
      }

      child {
        id
        due
        vendorProfile {
          id
          name
        }
      }

      job {
        type
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        backflowTest {
          jobId
          dateTested
          initialResult
          finalResult
          backflowAssemblyEdited
          properlyInstalled
          testable

          backflowAssembly {
            id
            testAnniversary
            waterSupplierProfile {
              id
              name
            }
            model {
              id
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
            waterService {
              id
              pin
            }
          }
        }
        attachments {
          id
        }
      }
    }
  }
`);

export const GET_INBOUND_ASSIGNMENTS_INDIVIDUAL = individual_gql(`#graphql
  query GetAssignments(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    inboundAssignments(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      jobId
      status
      created
      due
      assigned
      completed
      submitted

      parent {
        customerProfile {
          id
          name
          phones {
            id
            value
          }
        }
      }

      job {
        address {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        backflowTest {
          jobId
          dateTested
          initialResult
          finalResult
          testingCompanySubmitted
          backflowAssemblyEdited
          properlyInstalled
          testable
          waterSupplierProfile {
            id
            name
          }
          backflowAssembly {
            model {
              name
              backflowAssemblyMake {
                name
              }
            }
            serialNumber
            size
            type
            location
          }
        }
        attachments {
          id
        }
      }
    }
  }
`);

export type JobItemCompany = ResultOf<
  typeof GET_INBOUND_ASSIGNMENTS_COMPANY
>['inboundAssignments'][number];

export type JobItemWaterSupplier = ResultOf<
  typeof GET_INBOUND_ASSIGNMENTS_WATER_SUPPLIER
>['inboundAssignments'][number];

export type JobItemIndividual = ResultOf<
  typeof GET_INBOUND_ASSIGNMENTS_INDIVIDUAL
>['inboundAssignments'][number];
